import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

/**
 * Basic provider to provide the auth permission payload
 * to children. This can be used for UI specific gated content
 *
 * This component is less complicated than the "Gate" components and should
 * be used as their replacement.
 */
const PermissionProvider = ({ children }) => {
  const permissions = useSelector((state) => (state.auth.payload['cognito:groups'] || []).reduce((carry, current) => ({ ...carry, [current]: true }), {}))

  return (
    <React.Fragment>
      {children(permissions)}
    </React.Fragment>
  )
}

PermissionProvider.propTypes = {
  children: PropTypes.func.isRequired
}

export default PermissionProvider
